import header from "./real-estate-agent-advising-client.jpg";
import section1 from "./real-estate-agent-showing-house-plans.jpg";
import section2 from "./architecture-construction-people-technology.webp";
import section3 from "./architect-decide-blueprint.jpg";
import section4 from "./woman-designing-interior-with-tablet.jpg";
import section5 from "./architect-decide-blueprint-ecofriendly.webp";
import section6 from "./building-designer-studying-layout.jpg";
import section7 from "./real-estate-agent-evaluating-blueprints.webp";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
